import * as React from 'react';
import { GroupedList, IGroup, IGroupHeaderProps, IGroupFooterProps } from '@fluentui/react/lib/GroupedList';
import { Link } from '@fluentui/react/lib/Link';
// import { createListItems, createGroups, IExampleItem } from '@uifabric/example-data';
import { mergeStyleSets, IRawStyle } from '@fluentui/react/lib/Styling';
import { WebchatOptions } from '../../Redux/reduxState';
import { BaseCustomizationEntry } from '../customizeEntries';
import { CustomizationEntrySelector } from './customizationEntrySelector';
import { mergeStyles } from '@fluentui/react';
import { useEffect, useState } from 'react';
import { Icon } from '@fluentui/react/lib/Icon';
import { ContainerName } from '../../Redux/reducers/AppReducer';
import { scrollIntoContainer } from '../../utilities/scrollIntoContainer';

const subCategoryHeaderContainer = mergeStyles(
    {
        display: "flex",
        alignItems: "center",
        // margin: '10px 0',
        padding: '13px 16px',
        height: '58px !important',
        fontSize: '15px !important',
        paddingLeft: '16px !important',
        paddingRight: '16px !important',
        border: '1px solid var(--druid-color-border) !important',
        'border-left': 'unset !important',
        'border-right': 'unset !important',
        'background': 'white !important',
        color: 'var(--druid-color-text-primary) !important',
        'border-bottom': 'unset !important'
    }
);

const subCategoryContentContainer = mergeStyles(
    {
        paddingLeft: '16px !important',
        paddingRight: '16px !important',
    }
)

const subCategoryHeaderIcon = mergeStyles(
    {
        fontSize: '0.75rem',
        display: 'flex',
        aligntItems: 'center',
        cursor: 'pointer',
        marginLeft: 'auto'
    }
);

const subCategoryHeader = mergeStyles(
    {
        display: 'flex',
        alignItems: 'center',
        fontSize: '15px',
        color: 'var(--druid-color-text-primary)',
        fontWeight: 'bold',
        cursor: 'pointer',
    }
);

interface CustomizationEntrySubCategoryProps {
    entries: BaseCustomizationEntry[];
    subCategory: string;
    webchatOptions: WebchatOptions;
    updateStyleElement: (styleElementName: string, value: any, containerName?: ContainerName) => void;
    getStyleOptionValue: (key: any, containerName?: ContainerName) => any;
    revealRequested?: boolean;
    revealEntryId?: string;
    highlightEntryId?: string;
}

export const CustomizationEntrySubCategory = (props: CustomizationEntrySubCategoryProps) => {
    const { entries, subCategory, webchatOptions, updateStyleElement, getStyleOptionValue,
        revealRequested, revealEntryId, highlightEntryId
} = props;
    const [isCollapsed, setIsCollapsed] = useState(true);
    const headerRef = React.useRef<HTMLDivElement>(null);
    const contentRef = React.useRef<HTMLDivElement>(null);

    useEffect(() => {
        setIsCollapsed(true); // collapses subCategory headers
    }, [subCategory]);        // when new Category is selected, subcategory changes
    useEffect(() => {
        if (!revealRequested) {
            return;
        }
        setIsCollapsed(false);
        let inner = 0;
        const outer = requestAnimationFrame(() => {
            inner = requestAnimationFrame(() => {
                const entryElement = revealEntryId && contentRef.current
                    ? contentRef.current.querySelector('[data-entry-id="' + revealEntryId + '"]')
                    : null;
                scrollIntoContainer((entryElement as HTMLElement) || headerRef.current, 'start');
            });
        });
        return () => {
            cancelAnimationFrame(outer);
            cancelAnimationFrame(inner);
        };
    }, [revealRequested, revealEntryId]);


    // const getStyleOptionValue = (key: any) => {
    //     return prop(webchatOptions, key);
    // };

    // const prop = <T, K extends keyof T>(obj: T, key: K) => {
    //     return obj[key];
    // }

    
    
    return (
        <>
            <div
                ref={headerRef}
                onClick={()=> {setIsCollapsed(!isCollapsed)}}
                className={`${subCategoryHeaderContainer}`}
            >
                {/*  */}
                <span className={subCategoryHeader}>
                    {subCategory}
                </span>
                <div className={subCategoryHeaderIcon}>
                    <Icon iconName={isCollapsed ? "ChevronDownSmall" : "ChevronUpSmall"}/>
                </div>
            </div>
            {
                isCollapsed
                    ?   <div />
                    :   <div ref={contentRef} className={`${subCategoryContentContainer}`}>
                            {entries.map((entry: BaseCustomizationEntry) => (
                                    <CustomizationEntrySelector
                                        entry={entry}
                                        key={entry.id}
                                        value={getStyleOptionValue(entry.id, entry.containerName)}
                                        onChange={updateStyleElement}
                                        getStyleOptionValue={(key, containerName) => getStyleOptionValue(key, containerName || entry.containerName)}
                                        highlighted={highlightEntryId === entry.id}
                                    />
                                )
                            )}
                        </div>
            }
        </>
    );
};
